import { defineGame } from "./game-definition.js";
import { QUIZ_BUZZER_PHASES, canTransitionQuizBuzzer, scoreQuizAnswer, transitionQuizBuzzer } from "./quiz-buzzer-machine.js";
export const ODD_ONE_OUT_DEFAULT_CONFIG = Object.freeze({
    rounds: 10,
    answerDurationMs: 12_000,
    roundResultDurationMs: 4_000,
    correctBasePoints: 1_000,
    speedBonusMaxPoints: 600
});
const actions = ["START", "ANSWER", "ROUND_COMPLETE", "NEXT_ROUND", "FINISH", "PAUSE", "RESUME", "SKIP_ROUND", "END", "PLAY_AGAIN"];
export const ODD_ONE_OUT_DEFINITION = defineGame({
    key: "ODD_ONE_OUT",
    metadata: {
        slug: "trova-l-intruso",
        name: "Trova l’Intruso",
        description: "Individua l’elemento fuori posto tra quattro opzioni e conquista il bonus velocità.",
        icon: "🔍",
        catalogStatus: "available",
        maturity: "beta",
        hostAccess: true,
        minimumPlayers: 1,
        maximumPlayers: 100,
        capabilities: ["realtime", "qr-join", "public-display", "persistent-ranking", "questions"]
    },
    initialConfig: ODD_ONE_OUT_DEFAULT_CONFIG,
    supportedConfiguration: ["rounds", "answerDurationMs", "roundResultDurationMs", "correctBasePoints", "speedBonusMaxPoints"],
    configurationProfiles: {
        quick: { configuration: { rounds: 5, answerDurationMs: 9_000, roundResultDurationMs: 3_000 }, estimatedMinutes: 4 },
        standard: { configuration: {}, estimatedMinutes: 7 },
        extended: { configuration: { rounds: 20, answerDurationMs: 15_000 }, estimatedMinutes: 14 }
    },
    createInitialState: (config = {}) => ({
        phase: "LOBBY",
        roundNumber: 0,
        totalRounds: config.rounds ?? ODD_ONE_OUT_DEFAULT_CONFIG.rounds,
        pausedFromPhase: null
    }),
    states: QUIZ_BUZZER_PHASES,
    actions,
    canTransition: (state, action) => canTransitionQuizBuzzer(state.phase, action),
    transition: (state, action) => ({
        ...state,
        phase: transitionQuizBuzzer(state.phase, action, state.pausedFromPhase === "QUESTION" || state.pausedFromPhase === "ROUND_RESULT"
            ? { resumePhase: state.pausedFromPhase }
            : {})
    }),
    scoreDelta: (decision) => scoreQuizAnswer(decision === "CORRECT", ODD_ONE_OUT_DEFAULT_CONFIG.answerDurationMs, ODD_ONE_OUT_DEFAULT_CONFIG.answerDurationMs, ODD_ONE_OUT_DEFAULT_CONFIG),
    views: {
        host: "odd-one-out/host",
        player: "odd-one-out/player",
        display: "odd-one-out/display"
    },
    realtime: {
        clientToServer: ["host:start", "host:pause", "host:resume", "host:skip-round", "host:end", "host:play-again", "player:answer"],
        serverToClient: ["action-result", "action-error", "answer-result"]
    }
});
//# sourceMappingURL=odd-one-out-definition.js.map